export default "__VITE_ASSET__B2yi4MVn__"